<template>
  <Page :table="table" :pagination="pagination" :search-bar="searchBar">
    <template slot="imgUrl" slot-scope="{scope}">
      <el-image style="width: 59px; height: 34px" :src="scope.imgUrl[0]" :preview-src-list="scope.imgUrl"></el-image>
    </template>
    <template slot="approveStatus" slot-scope="{scope}">
      <span>{{ statusText(scope.approveStatus) }}</span>
    </template>
    <template slot="table-operate" slot-scope="{scope}">
      <div style="display: flex;justify-content: center;">
        <el-button type="text" :disabled="scope.approveStatus !==1" @click="handleApproval(scope)">审批</el-button>
      </div>
    </template>
    <Dialogs :title="title" :is-show-dialog="isShowPage" width="35%" @handleClick="handleClose">
      <div slot="content">
        <div class="subtitle mb15">内容详情</div>
        <div class="item">
          <span class="label">标题：</span>
          <div class="right-ct">{{ ruleForm.title }}</div>
        </div>
        <div class="item">
          <span class="label">封面图片：</span>
          <div class="right-ct">
            <el-image
              class="img"
              :src="ruleForm.imgUrl" 
              :preview-src-list="[ruleForm.imgUrl]">
            </el-image>
            <!-- <img :src="ruleForm.imgUrl" /> -->
          </div>
        </div>
        <div class="item">
          <span class="label">内容图片：</span>
          <div class="right-ct">
            <!-- <img :src="ruleForm.contentImgUrl" /> -->
            <el-image
              :src="ruleForm.contentImgUrl" 
              :preview-src-list="[ruleForm.contentImgUrl]">
            </el-image>
          </div>
        </div>
        <div class="item" v-if="ruleForm.articleAbstract">
          <span class="label">文章摘要：</span>
          <div class="right-ct">{{ ruleForm.articleAbstract }}</div>
        </div>
        <div class="item">
          <span class="label">正文内容：</span>
          <div class="right-ct content-detail" v-html="ruleForm.content"></div>
        </div>
        <div class="item" v-if="ruleForm.type === 3">
          <span class="label">报名时间：</span>
          <div class="right-ct">{{ ruleForm.registrationStartTime+' - '+ruleForm.registrationEndTime }}</div>
        </div>
        <div class="item" v-if="ruleForm.type === 3">
          <span class="label">活动时间：</span>
          <div class="right-ct">{{ ruleForm.activityStartTime+' - '+ruleForm.activityEndTime }}</div>
        </div>
        <div class="subtitle">内容审批</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="审批：" prop="approveStatus">
            <el-radio-group v-model="ruleForm.approveStatus">
              <el-radio :label="2">通过</el-radio>
              <el-radio :label="3">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注：" prop="remark" :rules="[{required: ruleForm.approveStatus === 3,message: '请输入备注', trigger: 'blur'},{ min: 1, max: 100, message: '长度在100字以内', trigger: 'blur' }]">
            <el-input type="textarea" v-model="ruleForm.remark" rows="3"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="btns">
        <el-button @click="handleCancle" style="margin-right: 20px;">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </Dialogs>
  </Page>
</template>
<script>
import Page from '@/components/Page2.vue'
import Dialogs from '@/components/page/Dialogs.vue'
import {approveList, submitApprove} from '@/api/contentApproval'
export default {
  components: {
    Page,
    Dialogs
  },
  props: {
    status: [Number, String]
  },
  data () {
    return {
      table: {
        selection: false, // 是否开启选择框
        index: true,
        tableInfo: [{
          key: 'contentType',
          name: '内容类型'
        }, {
          key: 'title',
          name: '标题'
        }, {
          key: 'imgUrl',
          name: '图片',
          type: 'img',
          width: '70px',
          height: '40px'
        }, {
          key: 'createUserName',
          name: '添加人'
        }, {
          key: 'createTime',
          name: '添加时间'
        }, {
          type: 'custom',
          key: 'approveStatus',
          name: '审批状态'
        }],
        tableData: []
      },
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        currentChange: (page) => {
          this.searchList(page)
        },
        sizeChange: (pageSize) => {
          this.params.size = pageSize
          this.searchList(1)
        }
      },
      searchBar: {
        list: [{
          type: 'select',
          prop: 'type',
          label: '内容类型',
          options: [{
            value: 1,
            label: 'banner'
          }, {
            value: 2,
            label: '文章'
          }, {
            value: 3,
            label: '活动'
          }],
          placeholder: '请选择类型'
        }, {
          type: 'input',
          prop: 'title',
          label: '标题',
          placeholder: '请输入标题'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: (params) => {
            this.params = { ...this.params, ...params }
            this.searchList(1)
          }
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      title: '审批',
      isShowPage: false,
      ruleForm: {
        title: '',
        articleAbstract: '',
        imgUrl: '',
        contentImgUrl: '',
        content: '',
        approveStatus: 2,
        remark: ''
      },
      params: {
        current: 1,
        size: 10,
        title: '',
        type: ''
      },
      types: ['banner', '文章', '活动']
    }
  },
  computed: {
    statusText () {
      return (val) => {
        const obj = {1: '待审批', 2: '已通过', 3: '未通过'}
        return obj[val]
      }
    }
  },
  mounted () {
    this.getApproveList()
    if (this.status !== 1) {
      this.table.tableInfo.push({
        key: 'remark',
        name: '审批备注'
      }, {
        key: 'approveUserName',
        name: '审批人'
      }, {
        key: 'approveTime',
        name: '审批时间'
      })
    }
  },
  methods: {
    async getApproveList () {
      const {data} = await approveList({...this.params, approveStatus: this.status})
      const {records, total} = data
      records.forEach(item => {
        item.contentType = this.types[item.type - 1]
      })
      this.$set(this.table, 'tableData', records)
      this.$set(this.pagination, 'total', total)
    },
    async submitApprove () {
      await submitApprove({
        id: this.ruleForm.id,
        approveStatus: this.ruleForm.approveStatus,
        remark: this.ruleForm.remark
      })
      this.$message.success('保存成功！')
      this.isShowPage = false
      this.getApproveList()
    },
    searchList (val) {
      if (val) {
        this.pagination.currentPage = val
        this.params.current = val
      }
      this.getApproveList()
    },
    resetList () {
      this.pagination.currentPage = 1
      this.params.current = 1
      this.params.title = ''
      this.params.type = ''
      this.searchList()
    },
    handleApproval (val) {
      this.isShowPage = true
      this.ruleForm.title = val.title
      this.ruleForm.articleAbstract = val.articleAbstract
      this.ruleForm.imgUrl = val.imgUrl
      this.ruleForm.contentImgUrl = val.contentImgUrl
      this.ruleForm.content = val.content
      this.ruleForm.approveStatus = 2
      this.ruleForm.remark = ''
      this.ruleForm.id = val.id
      this.ruleForm.type = val.type
      this.ruleForm.registrationStartTime = val.registrationStartTime
      this.ruleForm.registrationEndTime = val.registrationEndTime
      this.ruleForm.activityStartTime = val.activityStartTime
      this.ruleForm.activityEndTime = val.activityEndTime
    },
    handleClose (val) {
      this.isShowPage = val
    },
    handleCancle () {
      this.isShowPage = false
    },
    handleSave () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.submitApprove()
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  .subtitle {
    font-weight: 600;
  }
  .item {
    display: flex;
    margin-bottom: 20px;
    .right-ct {
      width: calc(100% - 100px);
      .img {
        width: 100px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
    .content-detail {
      white-space:pre-wrap;
      video {
        width: 100%;
      }
      img {
        width: 100%;
      }
    }
  }
  .label {
    width: 100px;
    text-align: right;
    padding-right: 12px;
  }
  .mb15 {
    margin-bottom: 15px;
  }
}
::v-deep .el-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}
</style>